import { PathPriority } from "building-types/walls/pathPriority";

export function pathPriorityOpposite(priority: PathPriority) {
  if (priority === PathPriority.NONE) {
    return priority;
  }
  return priority === PathPriority.LEFT ? PathPriority.RIGHT : PathPriority.LEFT;
}
